export default {
  name: "TelcomNetProtocol",
  props: ['showTelcomProtocol'],
  computed: {
    showTelcom: {
      get: function get() {
        return this.showTelcomProtocol;
      },
      set: function set(newVal) {
        this.$emit('update:showTelcomProtocol', newVal);
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {},
  mounted: function mounted() {}
};